import useSelectionState, { Ticket } from "../../../pages/agent/selection-state";
import { useMarkReadMutation } from "../../../__generated__/api";

export default function MarkRead(): null {
    const selectionState = useSelectionState();
    const [markRead] = useMarkReadMutation();

    const markSelectedRead = async (tickets?: Ticket[]) => {
        const selected = tickets ?? selectionState.getSelection();
        await markRead({
            variables: {
                chatIds: selected.toIdList("id"),
            },
        });
    };

    selectionState.registerMarkReadHandler(markSelectedRead);

    return null;
}

MarkRead.defaultProps = {
    refreshData: () => {
        // nothing
    },
};
